import {
  BugOutline,
  CheckCircleTwoTone,
  CheckOutline,
  CloseCircleFill,
  CloseCircleTwoTone,
  CloseOutline,
  CrownOutline,
  DeleteFill,
  DeleteOutline,
  EditFill,
  EditOutline,
  ExclamationCircleOutline,
  ExclamationOutline,
  FileExcelOutline,
  FileExcelTwoTone,
  FileTextOutline,
  FileTextTwoTone,
  InboxOutline,
  InfoCircleTwoTone,
  LineChartOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  MehTwoTone,
  PlusOutline,
  RightCircleTwoTone,
  SaveFill,
  SearchOutline,
  TagOutline,
  UserOutline,
  WarningFill,
  WarningOutline,
  WarningTwoTone,
} from '@ant-design/icons-angular/icons';

/**
 * Every icon the app renders must be listed here. ng-zorro preloads only the icons its own
 * components need; anything missing falls back to fetching `/assets/<theme>/<name>.svg`, which
 * the deployed backend answers with the SPA `index.html` — throwing IconNotFoundError.
 *
 * See https://the-lego-group.sentry.io/issues/EMMET-F
 */
export const icons = [
  BugOutline,
  CheckCircleTwoTone,
  CheckOutline,
  CloseCircleFill,
  CloseCircleTwoTone,
  CloseOutline,
  CrownOutline,
  DeleteFill,
  DeleteOutline,
  EditFill,
  EditOutline,
  ExclamationCircleOutline,
  ExclamationOutline,
  FileExcelOutline,
  FileExcelTwoTone,
  FileTextOutline,
  FileTextTwoTone,
  InboxOutline,
  InfoCircleTwoTone,
  LineChartOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  MehTwoTone,
  PlusOutline,
  RightCircleTwoTone,
  SaveFill,
  SearchOutline,
  TagOutline,
  UserOutline,
  WarningFill,
  WarningOutline,
  WarningTwoTone,
];
